<div class="failed-audits-container">
  @if (uiState == uiStateForTemplate.ShowData) {

    <form [formGroup]="failedAuditFilterFormGroup" class="filter-card">
      <h3 class="filter-title">Filter Failed Audits</h3>

      <div class="filter-grid">
        <mat-form-field appearance="outline">
          <mat-label>Source Type</mat-label>
          <mat-select placeholder="All sources" formControlName="sourceTypeId" data-testid="source-type-select">
            @for (sourceType of sourceTypes; track sourceType) {
              <mat-option [value]="sourceType.value" data-testid="source-type-option">
                {{ sourceType.label }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Event Type</mat-label>
          <mat-select placeholder="All event types" formControlName="eventTypeValue" data-testid="event-type-select">
            @for (eventType of auditEventTypes; track eventType) {
              <mat-option [value]="eventType.Value" data-testid="event-type-option">
                {{ eventType.Name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Date Range</mat-label>
          <mat-date-range-input [rangePicker]="campaignOnePicker">
            <input matStartDate placeholder="Start date" formControlName="fromDate" data-testid="from-date-input">
            <input matEndDate placeholder="End date" formControlName="toDate" data-testid="to-date-input">
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="campaignOnePicker"></mat-datepicker-toggle>
          <mat-date-range-picker #campaignOnePicker></mat-date-range-picker>
        </mat-form-field>

        <mat-form-field appearance="outline" class="search-field">
          <mat-label>Search in audit data</mat-label>
          <input matInput placeholder="Search commands, results, exceptions..." data-testid="generic-content-search-input" formControlName="genericContentSearch">
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
      </div>

      <div class="filter-actions">
        <button mat-stroked-button (click)="onResetClick()" data-testid="reset-button">
          Reset
        </button>
        <button mat-raised-button color="primary" type="submit"
                [disabled]="!failedAuditFilterFormGroup.valid"
                (click)="onFormSubmit()" data-testid="filter-button">
          Apply Filter
        </button>
      </div>
    </form>

    <ag-grid-angular
      class="ag-theme-quartz margin-top-med"
      data-testid="failed-audit-table"
      [tooltipShowDelay]=0
      [pagination]="true"
      [domLayout]="'autoHeight'"
      [suppressPaginationPanel]="true"
      (rowClicked)="onRowSelected($event)"
      overlayNoRowsTemplate="<span>No failed audits found</span>"
      (gridReady)="onGridReady($event)"
      [rowData]="failedAudits$ | async"
      [columnDefs]="failedAuditColDefs">
    </ag-grid-angular>
    <div class="custom-paginator">
      <span>{{ fromNumber }}</span> to <span>{{ toNumber }}</span> of <span
      class="margin-right-large">{{ totalRecords }}</span>
      <mat-icon (click)="onBtFirst()" [ngClass]="pageNumber === 1 ? 'disabled' : ''">first_page</mat-icon>
      <mat-icon (click)="onBtPrevious()" [ngClass]="pageNumber === 1 ? 'disabled' : ''">navigate_before</mat-icon>
      Page <span>{{ pageNumber }}</span> of <span>{{ totalPages }}</span>
      <mat-icon (click)="onBtNext()" [ngClass]="pageNumber === pagedAuditResponse?.TotalPages ? 'disabled' : ''">
        navigate_next
      </mat-icon>
      <mat-icon (click)="onBtLast()" [ngClass]="pageNumber === pagedAuditResponse?.TotalPages ? 'disabled' : ''">
        last_page
      </mat-icon>
    </div>

  }
</div>
